module.exports = __webpack_public_path__ + "static/epm-description-5e20db0576dbc41aaae0b12e34d2266a.jpg";